import { FC, PropsWithChildren, useRef } from 'react';

import { usePage } from '@inertiajs/react';

import Header, { HeaderRef } from '../components/Header';
import { MobileBottomNav } from '../components/MobileBottomNav';
import { AccountSidebar } from '../components/shared/AccountSidebar';
import {
    ProfileFlash,
    ProfileFlashMessages,
} from '../components/shared/ProfileFlashMessages';
import { SeoHead } from '../components/shared/SeoHead';
import { ServiceFeeAnnouncement } from '../components/shared/ServiceFeeAnnouncement';
import { ServiceFeeBalanceNotice } from '../components/shared/ServiceFeeBalanceNotice';
import { CartProvider } from '../context/cart-context';
import { CurrentUser } from '../types';
import { Metadata } from '../types/shared';

type PageProps = {
    metadata: Metadata;
    currentUser: CurrentUser;
    flash?: ProfileFlash;
    newNotificationPresent: boolean;
};

const Layout: FC<PropsWithChildren> = ({ children }) => {
    const { metadata, currentUser, flash, newNotificationPresent } =
        usePage<PageProps>().props;
    const headerRef = useRef<HeaderRef>(null);

    return (
        <CartProvider>
            <SeoHead metadata={metadata} />

            <div className="flex min-h-screen flex-col">
                <Header ref={headerRef} />

                <ProfileFlashMessages flash={flash} />

                <div className="container flex flex-1 gap-0 px-4 sm:px-6 lg:gap-8 lg:px-8">
                    <AccountSidebar />
                    <main className="min-w-0 flex-1">
                        <ServiceFeeAnnouncement />
                        <ServiceFeeBalanceNotice />
                        {children}
                    </main>
                </div>

                <MobileBottomNav
                    currentUser={currentUser}
                    onSearchClick={() => headerRef.current?.focusSearch()}
                    newNotificationPresent={newNotificationPresent}
                />
            </div>
        </CartProvider>
    );
};

export default Layout;
